import { defineSchema } from '../../schema-meta.ts';
import { registerSchema } from '../../generic-codec.ts';

export const StageWaveShopSchema = defineSchema({
  name: 'stageWaveShop',
  fields: [
    ['itemCount', 'number'],
    ['itemGroups', { kind: 'array', of: 'stageWaveShopItemGroup' }],
  ],
});

registerSchema(StageWaveShopSchema);
